import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 64px - 62px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CGMMD = () => {
  return (
    <>
      <Helmet title="GWMMD" />

      <Container>
        <iframe
          src="https://cgmmapp.clearwater.lre-up.com/map"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          title="Clearwater Groundwater Model Management Dashboard"
        />
      </Container>
    </>
  );
};

export default CGMMD;
